import { AnalyticsProvider, GoogleTagManager } from "@lonelyplanet/dotcom-analytics";
import * as React from "react";
export function AppProviders(_a) {
    var children = _a.children;
    return (React.createElement(AnalyticsProvider, { trackers: [GoogleTagManager] }, children));
}



//////////////////
// WEBPACK FOOTER
// ./app/shared/appProviders.tsx
// module id = y78e
// module chunks = 2